/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { statsBlockSchema } from "./statsBlockSchema.ts";
import { totalStatsBlockSchema } from "./totalStatsBlockSchema.ts";

export const dashboardStatsSchema = z.object({
	total: totalStatsBlockSchema,
	qr_menu: statsBlockSchema.optional(),
	device: statsBlockSchema.optional(),
});
